export function parseAccountStatus(data) {
  if (!data || typeof data.enabled !== 'boolean' || !['ACTIVE', 'SUSPENDED', 'BANNED'].includes(data.status) ||
    (data.status === 'SUSPENDED' ? typeof data.until !== 'string' || !Number.isFinite(Date.parse(data.until)) : data.until !== null) ||
    !Array.isArray(data.warnings) || data.warnings.length > 20 || data.warnings.some(warning =>
      !/^[a-f0-9-]{36}$/.test(warning.id) || typeof warning.message !== 'string' || warning.message.length > 1000 ||
      !Number.isFinite(Date.parse(warning.createdAt)))) throw new Error('invalid_account_status');
  return data;
}

// One observer per authenticated identity. An old response cannot update the
// next account; a failed refresh never clears an already known restriction.
export function observeAccountStatus(read, changed, failed) {
  let stopped = false, pending = null;
  async function refresh(force = false) {
    if (stopped || (pending && !force)) return;
    if (force) pending?.abort();
    const controller = new AbortController(); pending = controller;
    const timer = setTimeout(() => controller.abort(), 10000);
    let abort;
    try {
      const cancelled = new Promise((_, reject) => {
        abort = () => reject(new Error('account_status_cancelled'));
        controller.signal.addEventListener('abort', abort, { once: true });
      });
      const data = parseAccountStatus(await Promise.race([read(controller.signal), cancelled]));
      if (!stopped && pending === controller && !controller.signal.aborted) changed(data);
    } catch (error) { if (!stopped && pending === controller) failed(error); }
    finally { clearTimeout(timer); controller.signal.removeEventListener('abort', abort); if (pending === controller) pending = null; }
  }
  return { refresh, stop() { stopped = true; pending?.abort(); } };
}

export function accountModerationCopy(language) {
  return String(language).toLowerCase().startsWith('fr') ? {
    warning: 'Avertissement Qubiq', suspended: 'Compte temporairement suspendu', banned: 'Compte banni',
    until: 'Fin de la suspension :', explanation: 'Ton accès aux services Qubiq est restreint. Tu peux contester cette décision en nous contactant.',
    contact: 'Contacter Qubiq', account: 'Gérer ou supprimer mon compte', back: 'Retour',
    signout: 'Se déconnecter', retry: 'Actualiser', acknowledge: 'J’ai compris',
    error: 'Action non confirmée. Vérifie ta connexion et réessaie.',
  } : {
    warning: 'Qubiq warning', suspended: 'Account temporarily suspended', banned: 'Account banned',
    until: 'Suspension ends:', explanation: 'Your access to Qubiq services is restricted. You may appeal this decision by contacting us.',
    contact: 'Contact Qubiq', account: 'Manage or delete my account', back: 'Back',
    signout: 'Sign out', retry: 'Refresh', acknowledge: 'I understand',
    error: 'Action not confirmed. Check your connection and try again.',
  };
}
